import React from 'react';
import { ErrorFlashMessage } from 'components/utility/error-handlers';

export const ErrorFlash = ({ errors = { length: 0 }, detailed = false }) => {
  if (errors.length === 0) return null;
  return (
    <div style={{ marginTop: '24px' }}>
      <ErrorFlashMessage errors={errors} detailed={detailed} />
    </div>
  );
};
